import { getQueryStringParameter, hasQueryStringParameter } from 'owa-querystring';
import { isGulping } from 'owa-config/lib/bootstrapOptions';

export function initializeManifest() {
    updateManifestLink();
}

function updateManifestLink() {
    if (!isGulping()) {
        let newManifestUrl = `/mail/minimanifests/pwa.json`;
        if (hasQueryStringParameter('branch')) {
            newManifestUrl += `&branch=${getQueryStringParameter('branch')}`;
        }
        updateOrAddManifestLink(newManifestUrl);
    }
}

function updateOrAddManifestLink(newManifestUrl: string) {
    const elem = document.head.querySelector("link[rel='manifest']") as HTMLLinkElement;
    if (elem) {
        elem.href = newManifestUrl;
    } else {
        const newLinkElement = document.createElement('link');
        newLinkElement.rel = 'manifest';
        newLinkElement.href = newManifestUrl;
        document.head.appendChild(newLinkElement);
    }
}
